import { useState, useEffect } from "react";
import {
  Grid,
  Button,
  DialogContent,
  DialogActions,
  TextField,
  DataGrid,
  Autocomplete,
  DatePicker,
  Select,
  MenuItem,
} from "../../../../components";
import { InputErros, value } from "../../../../helpers";
import { notification } from "../../../../services";
import { formatPrice } from "../../../../utils";
import constantes from "../resources/constantes";

const NotaDebitoCreditoStepperContent = ({
  sendServer,
  activeStep,
  setActiveStep,
  handleImportarMercadorias,
  handleCancelarImportacao,
  handleDateChange,
  filtrosDialog,
  setFiltrosDialog,
  operacaoFiscal,
  setOperacaoFiscal,
  listaOperacoesFiscais,
  listaClientes,
  colunas,
  listaNfSaida,
  countNfSaida,
  documentoSelecionado,
  setDocumentoSelecionado,
  setItensSelecionados,
  buscarNfSaidaAvancado,
  itemSelectionModel,
  setItemSelectionModel,
  documentoSelectionModel,
  setDocumentoSelectionModel,
  handleInputChange,
}) => {
  const [listaItens, setListaItens] = useState([]);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const colunasItens = [
    {
      field: "descricao",
      headerName: "Produto",
      flex: 500,
    },
    {
      field: "valor",
      headerName: "Valor (R$)",
      flex: 300,
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "quantidade",
      headerName: "Qtd.",
      flex: 200,
      headerAlign: "start",
      align: "start",
      type: "number",
      editable: true,
    },
    {
      field: "subtotal",
      headerName: "Total Item (R$)",
      flex: 300,
      valueGetter: (params) => {
        const total = params.row.valor * params.row.quantidade;
        return formatPrice(total);
      },
    },
  ];

  useEffect(() => {
    if (documentoSelecionado && documentoSelecionado.nfSaidaItens) {
      const listaIdItens = documentoSelecionado.nfSaidaItens.map(
        (item) => item.id,
      );
      setItemSelectionModel(listaIdItens);
      setItensSelecionados(documentoSelecionado.nfSaidaItens);
      setListaItens(documentoSelecionado.nfSaidaItens);
    }
  }, [documentoSelecionado]);

  const filtrarDocumentoSelecionado = (nfSaidaIds) => {
    let documentoImportacao = null;
    let itensImportacao = [];
    const documentoFiltrado = listaNfSaida.filter((documento) => {
      if (nfSaidaIds.indexOf(documento.id) > -1) {
        if (documentoImportacao === null) {
          documentoImportacao = {
            ...documento,
          };
        }
        if (documentoImportacao?.clienteId == documento.clienteId) {
          const listaFiltrada = documento.nfSaidaItens
            .filter((produto) => produto.descricao)
            .map((produto) => ({
              ...produto,
              chaveAcessoReferencia: documento.chaveAcesso,
              numeroItemReferencia: produto.numeroItemNfe,
            }));
          documento.nfSaidaItens.forEach((produto) => {
            if (!produto.descricao) {
              adicionarInformacoesKit(produto, listaFiltrada);
            }
          });
          itensImportacao.push(...listaFiltrada);
          return documento;
        } else {
          setActiveStep(-1);
          return notification.alertaGenericos(
            "Documentos devem ser do mesmo cliente",
          );
        }
      }
    });
    delete documentoFiltrado[0].chaveAcesso;
    delete documentoFiltrado[0].status;
    setDocumentoSelecionado(() => ({
      ...documentoFiltrado[0],
      nfSaidaItens: itensImportacao,
      nfSaidaPagamentos: [],
    }));
  };

  const adicionarInformacoesKit = (produto, listaFiltrada) => {
    let produtoOrigem = null,
      proporcao = 1;
    if (produto.origemKitId) {
      produtoOrigem = listaFiltrada.find(
        (item) =>
          item.produtoId === produto.origemKitId &&
          item.nfSaidaId === produto.nfSaidaId,
      );
      proporcao = produto.quantidade / (produtoOrigem?.quantidade ?? 1);
    } else {
      produtoOrigem = listaFiltrada.find(
        (item) =>
          item.origemKitId === produto.produtoId &&
          item.nfSaidaId === produto.nfSaidaId,
      );
      proporcao = (produtoOrigem?.quantidade ?? 1) / produto.quantidade;
    }
    if (produtoOrigem) {
      if (produto.origemKitId) {
        produtoOrigem.tipo = "kit";
      }
      const itensKit = produtoOrigem.produtosKit || [];
      produtoOrigem.produtosKit = [
        ...itensKit,
        {
          produtoId: produto.produtoId,
          quantidade: produtoOrigem.saldoExportar * proporcao,
        },
      ];
    }
  };

  const handleAvancarStep = () => {
    if (activeStep === 0) {
      if (operacaoFiscal && !operacaoFiscal.tipoFinalidadeFiscal) {
        return notification.alertaGenericos(
          "Selecione as informações de operação fiscal",
        );
      }
    } else if (activeStep === 1) {
      if (documentoSelectionModel?.length) {
        filtrarDocumentoSelecionado(documentoSelectionModel);
      } else {
        return handleImportarMercadorias();
      }
    } else if (activeStep === 2 && !itemSelectionModel?.length) {
      return notification.alertaGenericos(
        "Selecione ao menos um produto para importar",
      );
    }
    setActiveStep(activeStep + 1);
  };

  const handleVoltarStep = () => {
    setActiveStep(activeStep - 1);
  };

  const filtrarItensSelecionados = (itemIds) => {
    let idsSelecionados = [];
    const idAdicionado = itemIds.filter(
      (id) => !itemSelectionModel.includes(id),
    );
    const idRemovido = itemSelectionModel.filter((id) => !itemIds.includes(id));

    const idSelecionado = idAdicionado[0] || idRemovido[0];
    const itemSelecionado = listaItens.find(
      (item) => item.id === idSelecionado,
    );

    if (itemSelecionado && itemSelecionado.origemKitId) {
      const kitIds = listaItens
        .filter(
          (item) =>
            item.origemKitId === itemSelecionado.origemKitId &&
            item.nfSaidaId === itemSelecionado.nfSaidaId,
        )
        .map((item) => item.id);

      const kitSelecionado = kitIds.every((id) =>
        itemSelectionModel.includes(id),
      );

      if (kitSelecionado) {
        idsSelecionados = itemIds.filter((id) => !kitIds.includes(id));
      } else {
        idsSelecionados = [...new Set([...itemIds, ...kitIds])];
      }
    } else {
      idsSelecionados = itemIds;
    }

    const selecionados = [];
    for (let itemId of idsSelecionados) {
      const itemEncontrado = listaItens.find((item) => item.id === itemId);
      selecionados.push(itemEncontrado);
    }
    setItensSelecionados(selecionados);

    setItemSelectionModel(idsSelecionados);
  };

  const onChangeAutocomplete = (name, value) => {
    setFiltrosDialog({
      ...filtrosDialog,
      [name]: value ? value.id : undefined,
    });
  };

  const renderTitleTipoNotaFiscal = () => {
    if (operacaoFiscal?.finalidade === "NOTA_DEBITO") {
      return "Tipo de Nota de Débito";
    } else if (operacaoFiscal?.finalidade === "NOTA_CREDITO") {
      return "Tipo de Nota de Crédito";
    } else {
      return "Tipo de Nota Fiscal";
    }
  };

  const renderSelectItensTipoNotaFiscal = () => {
    let itens = [];
    if (operacaoFiscal?.finalidade === "NOTA_DEBITO") {
      itens = constantes.tiposNotaDebito;
    } else if (operacaoFiscal?.finalidade === "NOTA_CREDITO") {
      itens = constantes.tiposNotaCredito;
    }

    return itens.map((item, index) => (
      <MenuItem key={`${item}-${index}`} value={item.value}>
        {item.label}
      </MenuItem>
    ));
  };

  switch (activeStep) {
    case 2:
      return (
        <>
          <DialogContent>
            <DataGrid
              rows={listaItens}
              columns={colunasItens}
              rowCount={listaItens.length}
              checkboxSelection
              selectionModel={itemSelectionModel}
              onRowSelectionModelChange={filtrarItensSelecionados}
              disableAcoes
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleVoltarStep}
              color="primary"
              variant="contained"
            >
              <i
                className="ph-fill ph-caret-left"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Anterior
            </Button>
            <Button
              onClick={handleImportarMercadorias}
              color="primary"
              variant="contained"
            >
              Importar
            </Button>
          </DialogActions>
        </>
      );
    case 1:
      return (
        <>
          <DialogContent>
            <Grid container spacing={2} className="mt-1 mb-4">
              <Grid item xs={2}>
                <DatePicker
                  id="dataEmissaoStart"
                  name="dataEmissaoStart"
                  label="Data Emissão De"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataEmissaoStart
                      ? filtrosDialog.dataEmissaoStart
                      : null
                  }
                  onChange={(date) =>
                    handleDateChange(date, "dataEmissaoStart")
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <DatePicker
                  id="dataEmissaoEnd"
                  name="dataEmissaoEnd"
                  label="Data Emissão Até"
                  format="dd/MM/yyyy"
                  value={
                    filtrosDialog?.dataEmissaoEnd
                      ? filtrosDialog.dataEmissaoEnd
                      : null
                  }
                  onChange={(date) => handleDateChange(date, "dataEmissaoEnd")}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  id="clienteId"
                  name="clienteId"
                  options={listaClientes}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.nomeRazaoSocial
                      ? `${option.id}` + ` - ` + `${option.nomeRazaoSocial}`
                      : ""
                  }
                  getOptionSelected={(option, value) =>
                    option?.nomeRazaoSocial === value?.nomeRazaoSocial
                  }
                  noOptionsText="Sem opções"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      variant={"outlined"}
                      error={inputErros.get("clienteId")}
                    />
                  )}
                  onChange={(e, value) =>
                    onChangeAutocomplete("clienteId", value)
                  }
                  value={value.autoComplete(
                    listaClientes,
                    filtrosDialog?.clienteId,
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="numeroDocumento"
                  name="numeroDocumento"
                  label="Nº Documento"
                  variant="outlined"
                  fullWidth
                  onChange={handleInputChange}
                  value={filtrosDialog?.numeroDocumento}
                />
              </Grid>
              <Grid item xs={2} className="d-flex align-items-center">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  fullWidth
                  sx={{ height: "51px" }}
                  onClick={() => buscarNfSaidaAvancado(filtrosDialog)}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#fff", fontSize: 18, marginRight: 10 }}
                  ></i>
                  Filtrar
                </Button>
              </Grid>
            </Grid>
            <DataGrid
              rows={listaNfSaida}
              rowCount={countNfSaida}
              columns={colunas}
              checkboxSelection
              selectionModel={documentoSelectionModel}
              onRowSelectionModelChange={(selectedIds) => {
                setDocumentoSelectionModel(selectedIds);
              }}
              paginationMode={"server"}
              sendServer={sendServer}
              disableAcoes
              noFilter
            />
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleVoltarStep}
              color="primary"
              variant="contained"
            >
              <i
                className="ph-fill ph-caret-left"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
              Anterior
            </Button>
            <Button
              onClick={
                documentoSelectionModel?.length
                  ? handleAvancarStep
                  : handleImportarMercadorias
              }
              color="primary"
              variant="contained"
            >
              {documentoSelectionModel?.length ? "Próximo" : "Prosseguir"}
              {!!documentoSelectionModel?.length && (
                <i
                  className="ph-fill ph-caret-right"
                  style={{ color: "#fff", fontSize: 18 }}
                ></i>
              )}
            </Button>
          </DialogActions>
        </>
      );
    default:
      return (
        <>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Autocomplete
                  id="operacaoFiscalId"
                  name="operacaoFiscalId"
                  required
                  options={listaOperacoesFiscais}
                  noOptionsText="Sem opções"
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.descricao ? `${option.descricao}` : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Operação Fiscal"
                      variant="outlined"
                      margin="normal"
                      error={inputErros.get("operacaoFiscalId")}
                      required
                    />
                  )}
                  onChange={(e, value) => {
                    setOperacaoFiscal(value);
                  }}
                  value={value.autoComplete(
                    listaOperacoesFiscais,
                    operacaoFiscal?.id,
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Select
                  id="tipoNotaFiscal"
                  name="tipoNotaFiscal"
                  value={operacaoFiscal?.tipoFinalidadeFiscal || ""}
                  label={renderTitleTipoNotaFiscal()}
                  margin="normal"
                  onChange={(e) =>
                    setOperacaoFiscal((prev) => ({
                      ...prev,
                      tipoFinalidadeFiscal: e.target.value,
                    }))
                  }
                  fullWidth
                  disabled={!operacaoFiscal}
                >
                  {renderSelectItensTipoNotaFiscal()}
                </Select>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className="m-3">
            <Button
              onClick={handleCancelarImportacao}
              color="padrao"
              variant="contained"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleAvancarStep}
              color="primary"
              variant="contained"
            >
              Próximo
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            </Button>
          </DialogActions>
        </>
      );
  }
};

export default NotaDebitoCreditoStepperContent;
